import { Box, Button, Dialog, DialogActions, DialogContent, Grid, IconButton, Typography } from "@mui/material";
import { LocalizationProvider, StaticDatePicker } from '@mui/x-date-pickers';import { useForm } from "react-hook-form";
import { WSIcons } from "../../commonFunctions/iIcons";
import { useState } from "react";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
interface CardTopUpProps {
    open: boolean;
    onClose: () => void;
  }
  
  export const DayClose: React.FC<CardTopUpProps> = ({ open,onClose }) => {
      const { handleSubmit, control, register } = useForm();
      const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());

      
    
    const onSubmit = async (data: any) => {
      debugger;
      console.log("onsubmit===>", data); // You can perform any action with the submitted data here
    };
    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <Grid display="flex" alignItems="center" bgcolor="green" p={1} color="white">
        
        <Typography  variant="h6" component="div" sx={{ flexGrow: 1}}>
          Day Close
        </Typography>
        <IconButton  color="inherit" onClick={onClose}>
          <WSIcons.CloseIcon />
        </IconButton>
      </Grid>

      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={5}>
        <Typography variant="h6"  paragraph>
          Open New Day And Freeze Audited Data
        </Typography>
        <Typography variant="body1" paragraph>
          This will open a new business day. All transactions added from this will be recorded for this date. Upon freezing data, only privileged users will be able to amend it.
        </Typography>
</Grid>
        <Grid item xs={12} sm={6} >
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <StaticDatePicker
              displayStaticWrapperAs="desktop"
              value={selectedDate}
              onChange={(newValue) => setSelectedDate(newValue)}
            />
          </LocalizationProvider>
        </Grid>
        </Grid>
      </DialogContent>

      <Grid
            item
            sx={{
              backgroundColor: "#333",
              padding: "1rem",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: "auto", // Pushes the footer to the bottom
            }}
          >
            <Grid container spacing={2} alignItems="center" gap={3}>
              <Grid item>
                <WSIcons.GTranslateIcon sx={{ color: "white" }} />
              </Grid>
            </Grid>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "green",
                "&:hover": {
                  backgroundColor: "#388e3c",
                },
              }}
              onClick={handleSubmit(onSubmit)}
            >
              Finish
            </Button>
          </Grid>
    </Dialog>

    )
}